import React, { ReactNode} from "react";

import AppSidebar from "../../components/appSidebar/AppSidebar";
import { CommonContainer } from "../../components/commonContainer/commonContainer";
import { SidebarProvider } from "../../components/ui/common/sidebar";
import useWindowDimensions from "../../hooks/windowsSize";
import { Header } from "../../components/index";

import "../mainContanier.scss";

interface MainContentViewLayoutProps {
  children: ReactNode ;
  currentPath: string;
}

// Redesigned layout: AppSidebar as a full-height flex sibling of the
// header+content column, active behind ENABLE_APP_SIDEBAR_REDESIGN.
export const MainContentViewLayoutNew = ({
  children,
  currentPath,
}: MainContentViewLayoutProps) => {
  const { width } = useWindowDimensions();

  return (
    <SidebarProvider>
      {/*
        Sidebar is a full-height flex sibling of the header+content column -
        NOT stacked below a full-width header - so it always spans edge to
        edge on the left, with the header sitting beside it, not above it.
        Below the desktop breakpoint AppSidebar renders itself as a fixed
        off-canvas drawer (see Sidebar in ui/common/sidebar.tsx), so it no
        longer needs a `contentHide` wrapper here to stay off tablet/mobile.
      */}
      <div className="tw-flex tw-min-h-screen" style={{ width: width }}>
        <AppSidebar />
        <div className="tw-flex tw-min-h-screen tw-min-w-0 tw-flex-1 tw-flex-col">
          <Header />
          <div className="rightContentMainRedesign">
            <CommonContainer
              currentPath={currentPath}
              styles={`customMainBottomContainer`}
            >
              {children}
            </CommonContainer>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};
